export default "__VITE_ASSET__fb4ed980__"